import React from "react";
import "./tablet-nav-overlay.scss";

export interface TabletNavOverlayProps {
  readonly isOpen: boolean;
  readonly onClose: () => void;
  readonly children: React.ReactNode;
}

/**
 * Tablet sidebar overlay with backdrop.
 * Open/close via header toggle, backdrop click, or nav item selection (US-05 Scenario 1).
 * Dedicated keyboard/focus a11y (former Scenario 2) is out of scope — UX owns NAF a11y standards.
 */
const TabletNavOverlay: React.FC<TabletNavOverlayProps> = ({ isOpen, onClose, children }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <dialog
      open
      className="tablet-nav-overlay"
      aria-label="Navigation"
      data-testid="tablet-nav-overlay"
    >
      <button
        type="button"
        className="tablet-nav-overlay__backdrop"
        aria-label="Close navigation"
        onClick={onClose}
        data-testid="tablet-nav-overlay-backdrop"
      />
      <div
        id="tablet-nav-overlay-panel"
        className="tablet-nav-overlay__panel"
        data-testid="tablet-nav-overlay-panel"
      >
        {children}
      </div>
    </dialog>
  );
};

export default TabletNavOverlay;
